var map = {
	"./assets/img/Passport.svg": 2679,
	"./assets/img/backpack.svg": 10,
	"./assets/img/bag.svg": 935,
	"./assets/img/bg.png": 7362,
	"./assets/img/bg1.png": 5367,
	"./assets/img/bg_mobile.png": 5839,
	"./assets/img/bg_pc.png": 1127,
	"./assets/img/btn_go.png": 6597,
	"./assets/img/camera.svg": 4092,
	"./assets/img/cash.svg": 530,
	"./assets/img/credit-card.svg": 3578,
	"./assets/img/culturetur.svg": 4895,
	"./assets/img/ekotur.svg": 5297,
	"./assets/img/go.svg": 9994,
	"./assets/img/guide.svg": 3376,
	"./assets/img/guide_block.gif": 4433,
	"./assets/img/health.gif": 6621,
	"./assets/img/infrastructure/astrakhan/astrakhan_aero.png": 6366,
	"./assets/img/infrastructure/astrakhan/astrakhan_kreml.png": 300,
	"./assets/img/infrastructure/astrakhan/astrakhan_teatr.png": 8631,
	"./assets/img/infrastructure/astrakhan/azimut.png": 2746,
	"./assets/img/infrastructure/barnaul/barnaul_aero.png": 3958,
	"./assets/img/infrastructure/barnaul/barnaul_hotel.png": 7895,
	"./assets/img/infrastructure/barnaul/kgbu.png": 2401,
	"./assets/img/infrastructure/barnaul/teatr_barnaul.png": 7060,
	"./assets/img/infrastructure/kazan/gavan.png": 3572,
	"./assets/img/infrastructure/kazan/kazan_aero.png": 6328,
	"./assets/img/infrastructure/kazan/kazan_ermitazh.png": 1643,
	"./assets/img/infrastructure/kazan/kazan_zhd.png": 4766,
	"./assets/img/infrastructure/moscow/domododevo.png": 5453,
	"./assets/img/infrastructure/moscow/kreml.png": 5938,
	"./assets/img/infrastructure/moscow/muzei_zapovednik.png": 7625,
	"./assets/img/infrastructure/moscow/radisson.jpg": 9737,
	"./assets/img/infrastructure/samara/lotte.png": 166,
	"./assets/img/infrastructure/samara/samara_aero.png": 1831,
	"./assets/img/infrastructure/samara/samara_kos.png": 3897,
	"./assets/img/infrastructure/samara/samara_zhd.png": 3305,
	"./assets/img/infrastructure/simferopol/muzei_zapovednik.png": 9377,
	"./assets/img/infrastructure/simferopol/simferopol_aero.png": 1657,
	"./assets/img/infrastructure/simferopol/simferopol_hotel.png": 5531,
	"./assets/img/infrastructure/simferopol/simferopol_zhd.png": 3092,
	"./assets/img/location.svg": 8465,
	"./assets/img/logo_yaft.png": 4876,
	"./assets/img/moon.png": 158,
	"./assets/img/peshotur.svg": 2158,
	"./assets/img/phone.svg": 7491,
	"./assets/img/pods.svg": 1261,
	"./assets/img/route.svg": 7506,
	"./assets/img/settings.svg": 462,
	"./assets/img/talon.svg": 945,
	"./assets/img/ticket.svg": 4887,
	"./assets/img/type/cultural/kazan/dvorets.png": 2296,
	"./assets/img/type/cultural/kazan/kazan_kreml.png": 7442,
	"./assets/img/type/cultural/kazan/spasskaya_bashnya.png": 165,
	"./assets/img/type/cultural/samara/dacha_kupsa.png": 6765,
	"./assets/img/type/cultural/samara/naberezhnaya.png": 3797,
	"./assets/img/type/cultural/samara/ploshad.png": 25,
	"./assets/img/type/cycle/moscow/art_park.jpg": 6519,
	"./assets/img/type/cycle/moscow/priokskie_prostori.jpg": 9268,
	"./assets/img/type/cycle/moscow/tberskoy_gubernii.jpg": 2738,
	"./assets/img/type/eco/samara/botanicheskiy.png": 4018,
	"./assets/img/type/eco/samara/zagorodniy.png": 4899,
	"./assets/img/type/eco/samara/zigulevskiy_zapovednik.png": 9537,
	"./assets/img/type/hiking/astrakhan/puteshestvie_po_astrakhan.jpg": 1749,
	"./assets/img/type/hiking/astrakhan/splav_astrakhan.jpg": 4146,
	"./assets/img/type/hiking/barnaul/181225_350x280.jpg": 600,
	"./assets/img/type/hiking/barnaul/189789_350x280.jpeg": 5102,
	"./assets/img/type/hiking/barnaul/bolshoe_puteshestvie.jpg": 3132,
	"./assets/img/type/hiking/barnaul/shavlinskoe_ozera.jpeg": 889,
	"./assets/img/type/hiking/simferopol/gori_krim.jpg": 4578,
	"./assets/img/type/hiking/simferopol/krim.jpg": 3136,
	"./assets/img/type/hiking/simferopol/sudak.jpg": 5073,
	"./assets/img/usb.svg": 2456,
	"./assets/img/user.svg": 6743,
	"./assets/img/velotur.svg": 8969,
	"./assets/img/weather.svg": 7236,
	"./assets/img/weatherPage.gif": 4562,
	"./assets/img/weather_block.png": 6050,
	"./assets/img/Облачко.svg": 2996,
	"./assets/logo.png": 6949,
	"./assets/logo_yaft.png": 7570,
	"./assets/style/nullstyle.scss": 3175,
	"./assets/style/styles.scss": 2988
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7148;